export default {
  notifications: {
    title: "الإشعارات",
    mark_all: "تحديد الكل كمقروء",
    empty: "لا توجد إشعارات"
  }
};